import { render, staticRenderFns } from "./AccaTerms.vue?vue&type=template&id=31becfd7"
import script from "./AccaTerms.vue?vue&type=script&lang=js"
export * from "./AccaTerms.vue?vue&type=script&lang=js"
import style0 from "./AccaTerms.vue?vue&type=style&index=0&id=31becfd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports